import { getFileBuffer, get, post, postJson } from '../tools/async-tool'
// import {Message} from 'element-ui';
import showErr from './showErr'

// 因为拿到的是二进制流数据，所以报错 500时，这边拿到的也是 arrayBuffer 报错信息
const transferArrayBufferToJSON = (arrayBufferData) => {
  var uint8_msg = new Uint8Array(arrayBufferData)
  // 解码成字符串
  var decodedString = String.fromCharCode.apply(null, uint8_msg)
  console.log(decodedString)
  var data = null
  // parse,转成json数据
  try {
    data = JSON.parse(decodedString)
  } catch (error) {
    data = decodedString
  }
  return data
}

export function downloadFileApi (url, params, cb, failCb) {
  // let url = '/statics/payment_flow/excel';
  return getFileBuffer(url, params, {
    // headers: {
    //   'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    //   'content-disposition': `attachment; filename=*.xlsx`
    // },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)

    window.__bl && window.__bl.error({name: '下载文件失败', message: JSON.stringify(err)}, {
      filename: 'tools/get-ststoken.js',
      lineno: 46,
      colno: 0
    })
  })
}

export function getLessonRecordExcel (cb, params, failCb = null) {
  let url = '/sign/list/excel'

  return get(url, params, {
    headers: {
      'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': `attachment; filename=*.xlsx`
    },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)
  })
}

export function getTeacherPerformanceStatisticsExcel (cb, params, failCb = null) {
  let url = '/statics/pc/teacher_performance/excel'

  return get(url, params, {
    headers: {
      'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': `attachment; filename=*.xlsx`
    },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)
  })
}

// 报名列表导出
export function getSignupOrderExcel (cb, params, failCb = null) {
  let url = '/statics/student_orders/by_period/excel'

  return get(url, params, {
    headers: {
      'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': `attachment; filename=*.xlsx`
    },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)
  })
}

// 报名成功明细导出
export function getPaidOrderExcel (cb, params, failCb = null) {
  let url = '/statics/student_order_items/by_period/excel/v2'

  return get(url, params, {
    headers: {
      'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': `attachment; filename=*.xlsx`
    },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)
  })
}

// 工资条导出
export function getTeacherSalaryExcel (cb, params, failCb = null) {
  let url = '/salary/salary_slips/export'

  return get(url, params, {
    headers: {
      'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': `attachment; filename=*.xlsx`
    },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)
  })
}

// 学员课卡导出
export function downloadStudentCardExcel (cb, params, failCb = null) {
  let url = '/student_cards/by_org/export/v2'

  return get(url, params, {
    headers: {
      'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': `attachment; filename=*.xlsx`
    },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)
  })
}

// 班级管理导出
export function downloadClassesExcel (cb, params, failCb = null) {
  let url = '/classes/list/export'

  return get(url, params, {
    headers: {
      'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': `attachment; filename=*.xlsx`
    },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)
  })
}
export function downloadClassesStudentInfoExcel (cb, params, failCb = null) {
  let url = '/classes/student_info/export'

  return get(url, params, {
    headers: {
      'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': `attachment; filename=*.xlsx`
    },
    responseType: 'arraybuffer'
  }).then(res => {
    cb(res)
  }, err => {
    // err.body = transferArrayBufferToJSON(err.body)
    showErr(err)

    failCb && failCb(err)
  })
}
// 试用期过期的机构申请延长试用期
export function applyTrialOrgProbationPeriod (cb, params, failCb = null) {
  let url = '/org/trial_application.json'

  return postJson(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

// token 是否已经失效
export function checkTokenExpired (cb, params, failCb = null, notShowErr = false) {
  let url = '/check_token/expired'

  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    // console.log(err, 'err /check_token/expired')
    // 这样写，存疑
    if (err.status == 403) {
      if (err.body && (err.body.reason === 'NO_OPERATION_PERMISSION' || err.body.reason === 'NO_VIEW_PERMISSION')) {

      } else {
        err.body.error = '登录失效，请重新登录'
      }
    }
    if (!notShowErr) {
      showErr(err)
    }

    failCb && failCb(err)
  })
}

export function getCurrentOrg (cb, params, failCb = null) {
  let url = '/org'
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function getProfile (cb, params, failCb = null) {
  let url = '/profile'
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

// huke互客自动登录

export function hukeAutoLogin (cb, params, failCb = null) {
  const url = '/huke/auto_login'

  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function ossFindAttachments (cb, params, failCb = null) {
  let url = '/oss/find_attachments.json'

  return postJson(url, params).then(res => {
    cb(res.body)
  }, (err) => {
    showErr(err)
    failCb && failCb(err)
  })
}
